"use client"

import type React from "react"

interface WiFiFormProps {
  ssid: string
  password: string
  encryption: "WPA" | "WEP" | "nopass"
  hidden: boolean
  onSsidChange: (ssid: string) => void
  onPasswordChange: (password: string) => void
  onEncryptionChange: (encryption: "WPA" | "WEP" | "nopass") => void
  onHiddenChange: (hidden: boolean) => void
}

const WiFiForm: React.FC<WiFiFormProps> = ({
  ssid,
  password,
  encryption,
  hidden,
  onSsidChange,
  onPasswordChange,
  onEncryptionChange,
  onHiddenChange,
}) => {
  return (
    <div className="form-group">
      <label htmlFor="wifi-ssid-input">Network Name (SSID):</label>
      <input
        id="wifi-ssid-input"
        type="text"
        value={ssid}
        onChange={(e) => onSsidChange(e.target.value)}
        placeholder="WiFi Network Name"
        className="text-input"
      />

      <label htmlFor="wifi-password-input">Password:</label>
      <input
        id="wifi-password-input"
        type="password"
        value={password}
        onChange={(e) => onPasswordChange(e.target.value)}
        placeholder="WiFi Password"
        className="text-input"
      />

      <label htmlFor="wifi-encryption-input">Encryption:</label>
      <select
        id="wifi-encryption-input"
        value={encryption}
        onChange={(e) => onEncryptionChange(e.target.value as "WPA" | "WEP" | "nopass")}
        className="select-input"
      >
        <option value="WPA">WPA/WPA2</option>
        <option value="WEP">WEP</option>
        <option value="nopass">No Password</option>
      </select>

      <div className="checkbox-group">
        <input
          id="wifi-hidden-input"
          type="checkbox"
          checked={hidden}
          onChange={(e) => onHiddenChange(e.target.checked)}
          className="checkbox-input"
        />
        <label htmlFor="wifi-hidden-input">Hidden Network</label>
      </div>
    </div>
  )
}

export default WiFiForm
